module.exports = __webpack_public_path__ + "img/online-img.0897a50.png";